<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page

========================================================================================== -->

<template>
  <div id="page-assignment-view">
    <vs-alert v-if="errorOccurred" color="danger" title="Assignment Not Found">
      <span>Assignment record with id: not found. </span>
      <span>
        <span>Check </span
        ><router-link :to="{ name: 'admin-list-examedge-assignment' }" class="text-inherit underline">All Assignments</router-link>
      </span>
    </vs-alert>

    <div v-if="assignmentData" id="assignment-data">
      <!--- TOP SET BANNER START --->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <div
            class="rounded-lg w-full"
            style="
              background-image: url(https://cdn.discordapp.com/attachments/733851758211629347/954057924391600218/BG.png);
              box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
            "
          >
            <div class="knowledge-base-jumbotron-content rounded-lg lg:p-12 sm:p-10 p-8" style="backdrop-filter: blur(10px)">
              <div class="flex justify-between items-center">
                <div>
                  <h1 class="text-white w-full" style="font-size: 4rem">{{ assignmentData.name }}</h1>
                </div>
                <img class="rounded" :src="assignmentData.thumbnail" v-if="assignmentData.thumbnail" width="150px" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--- TOP SET BANNER END --->

      <!--- SET ACTION BAR START --->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col grid grid-cols-3 gap-8 w-full">
          <vx-card
            class="p-6 cursor-pointer text-white"
            @click="$router.push(`/a/examedge/banks/${assignmentData.bank_id}`)"
            :style="`background-image: linear-gradient(118deg, rgba(var(--vs-warning), 0.4), rgba(var(--vs-warning), .2)), url(${cardBgImgURL})`"
          >
            <div class="flex items-center justify-center">
              <feather-icon icon="ArrowLeftCircleIcon" svgClasses="h-16 w-16" />
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Back To<br />Bank</h2>
            </div>
          </vx-card>
          <vx-card
            class="p-6 cursor-pointer"
            @click="$router.push(`/a/examedge/assignments/${assignmentData.id}/edit`)"
            :style="`background-image: linear-gradient(118deg, rgba(var(--vs-success), 0.4), rgba(var(--vs-success), .2)), url(${cardBgImgURL})`"
          >
            <div class="flex items-center justify-center">
              <feather-icon icon="EditIcon" svgClasses="h-16 w-16" />
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Edit<br />Assignment</h2>
            </div>
          </vx-card>

          <!--- <vx-card class="p-6 cursor-pointer text-white" @click="$router.push(`/a/examedge/assignments/${assignmentData.id}/builder`)"
                   :style="`background-image: linear-gradient(118deg, rgba(var(--vs-primary), 0.4), rgba(var(--vs-primary), .2)), url(${cardBgImgURL})`">
            <div class="flex items-center justify-center">
              <feather-icon icon="ZapIcon" svgClasses="h-16 w-16"/>
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Assignment<br>Builder</h2>
            </div>
          </vx-card> -->
          <vx-card
            class="p-6 cursor-pointer text-white"
            @click="confirmDeleteAssignment"
            :style="`background-image: linear-gradient(118deg, rgba(var(--vs-danger), 0.4), rgba(var(--vs-danger), .2)), url(${cardBgImgURL})`"
          >
            <div class="flex items-center justify-center">
              <feather-icon icon="TrashIcon" svgClasses="h-16 w-16" />
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Archive<br />Assignment</h2>
            </div>
          </vx-card>
        </div>
      </div>
      <!--- SET ACTION BAR END --->

      <!--- SET SHOW INFORMATION START--->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Assignment Id</h3>
            <h3 class="font-light">{{ assignmentData.id }}</h3>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Assignment Status</h3>
            <h3 class="capitalize font-light">{{ assignmentData.status }}</h3>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Assignment Questions</h3>
            <h3 class="capitalize font-light"></h3>
          </vx-card>
        </div>
      </div>
      <!--- SET SHOW INFORMATION END--->
    </div>
    <div class="simple-spinner" v-else>
      <span></span>
    </div>
  </div>
</template>

<script>
import Prism from 'vue-prism-component'
import vSelect from 'vue-select'
import ListQuestions from '../../questions/question-list/ListQuestions'

export default {
  data () {
    return {
      cardBgImgURL: 'https://media.discordapp.net/attachments/733851758211629347/954057924630700132/BG2.png?width=1352&height=676',

      assignmentData: null,
      assignmentPracticeData: null,
      assignmentDescriptionCounter: false,
      errorOccurred: false
    }
  },
  components: {
    Prism,
    vSelect,
    ListQuestions
  },
  methods: {
    fetchAssignmentDetails (id) {
      this.$http
        .get(`testprep/assignments/${id}`)
        .then((response) => {
          if (response.status === 200) {
            this.assignmentData = response.data.data
          }
        })
        .catch((error) => {
          this.errorOccurred = true
          this.error_msg = error
        })
    },
    confirmDeleteAssignment () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Archive',
        text: 'Please confirm you want to archive this assignment.',
        accept: this.deleteAssignment,
        acceptText: 'Archive'
      })
    },
    addQuestionSearch (question) {
      this.$http.get(`testprep/questions?search=${question}&amount=3`).then((response) => {
        if (response.data) {
          this.addQuestionResults = response.data.data
        }
      })
    },
    addQuestionToAssignment (id) {
      if (this.assignmentData.questions.includes(id)) return this.handleError('', 'Question is already inside of assignment', 'You cannot add a question into a assignment twice')
      this.$vs.loading()
      this.$http
        .post(`testprep/assignments/${this.assignmentData.id}/questions`, [id])
        .then((response) => {
          if (response.status === 200) {
            this.questionTableKey++
            this.fetchAssignmentDetails(this.assignmentData.id)
            this.$vs.loading.close()
          }
        })
        .catch((exception) => {
          this.$vs.loading.close()
          this.handleError(exception, 'Failed to add question to assignment')
        })
    },
    createQuestion () {
      this.$vs.loading()
      this.$http
        .post('testprep/questions/create', this.createQuestionDetails)
        .then((response) => {
          if (response.status === 200) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Created assignment successfully',
              text: 'New question has been created.',
              color: 'success',
              position: 'top-right'
            })
            this.addQuestionToAssignment(response.data.data.id)
            this.createQuestionDetails = {
              question: '',
              definition: '',
              definition_extended: '',
              definition_image: ''
            }
          }
        })
        .catch((exception) => {
          this.$vs.loading.close()
          this.handleError(exception, 'Failed to create question')
        })
    },
    deleteAssignment () {
      this.$vs.loading()

      this.$http
        .delete(`testprep/assignments/${this.$route.params.assignmentId}`)
        .then((response) => {
          this.$vs.loading.close()

          if (response.status === 200) {
            this.$router.push('/a/examedge/assignments')

            return this.$vs.notify({
              color: 'success',
              title: 'Assignment Archived',
              text: 'You have successfully archived this assignment',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }
        })
        .catch((exception) => {
          this.$vs.loading.close()
          this.handleError(exception, 'Failed to archive assignment')
        })
    },
    refreshAssignmentCache (id) {
      this.$vs.loading()

      this.$http
        .get(`testprep/assignments/${id}/cache`)
        .then((response) => {
          this.$vs.loading.close()

          if (response.status === 200) {
            return this.$vs.notify({
              color: 'success',
              title: 'Cache Cleared',
              text: 'The assignment cache has been cleared successfully',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }
        })
        .catch((exception) => {
          this.$vs.loading.close()
          this.handleError(exception, 'Failed to Clear Cache')
        })
    },
    handleError (exception, title, text) {
      let error = 'An unknown error occurred while adding question to assignment'
      if (exception.response) {
        error = exception.response.data.error.description
      }
      if (text) {
        error = text
      }
      return this.$vs.notify({
        title,
        text: error,
        color: 'danger',
        position: 'top-right'
      })
    }
  },
  created () {
    this.fetchAssignmentDetails(this.$route.params.assignmentId)
    this.addQuestionSearch('')
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-assignment-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }

  @media (min-width: 1200px) and (max-width: 1700px) {
    .image-assignment {
      display: none;
    }
    .assignment-col {
      width: 0 !important;
      min-height: 2.05vh;
    }
    .welcome-col {
      width: 100% !important;
    }
  }
}
</style>
